"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = require("../index");
var classnames_1 = __importDefault(require("classnames"));
exports.default = (function () {
    var _a = (0, react_1.useContext)(index_1.AppContext), attemptedCancel = _a.attemptedCancel, goToNextStep = _a.goToNextStep, isFinalStep = _a.isFinalStep, canGoNext = _a.canGoNext, isReadyForSubmit = _a.isReadyForSubmit, submitCancel = _a.submitCancel, pathNext = _a.pathNext, isCancellingOrder = _a.isCancellingOrder;
    var buttonText = (0, react_1.useMemo)(function () {
        // if attemptedCancel is true that means that we have gone through all of the steps already
        if (attemptedCancel) {
            return 'Return to My Account';
        }
        return !isFinalStep ? 'Continue' : 'Request Cancellation';
    }, [attemptedCancel, isFinalStep]);
    var handleButtonClick = function () {
        // final button click after last confirmation page should lead back to the account page
        if (attemptedCancel) {
            window.location.href = '/account';
        }
        else {
            canGoNext && pathNext ? goToNextStep() : submitCancel();
        }
    };
    // not finished with first step if there is a next path but can't go next
    var firstStepNotFinished = !!pathNext && !canGoNext;
    var lastStepNotFinished = isFinalStep && !isReadyForSubmit;
    return (react_1.default.createElement("div", { className: 'grid-x padding-5 bg-white border-seashell', style: { borderTop: 'solid' } },
        react_1.default.createElement("button", { disabled: firstStepNotFinished || lastStepNotFinished || isCancellingOrder, className: (0, classnames_1.default)('small-12 large-6 large-offset-3 grid-container padding-5 text-white', canGoNext || (isFinalStep && isReadyForSubmit && !isCancellingOrder) ? 'bg-wisteria' : 'bg-gray'), onClick: handleButtonClick }, isCancellingOrder ? 'Requesting Cancellation...' : buttonText)));
});
